module.exports = __webpack_public_path__ + "img/berechnung_option_3.0029dd55.png";